<template>
  <div class="contacts">
    <contacts-google-map></contacts-google-map>
    <div class="contacts-details-and-feedback">
      <section
        class="contacts-details"
        itemscope itemtype="http://schema.org/JewelryStore"
      >
        <h1>
          ЧПУП «<span itemprop="name">Ювелирная фирма «Стиль»</span>
        </h1>
        <contacts-address></contacts-address>
        <contacts-phones></contacts-phones>
        <contacts-working-hours
          v-if="areWorkingHoursReady"
          v-bind:working-hours="workingHours"
        ></contacts-working-hours>
        <contacts-other></contacts-other>
        <div class="logo-wrapper">
          <img
            src="/static/images/logo/logo-black-background.svg"
            alt="Ювелирная фирма «Стиль»"
            class="logo"
            itemprop="image"
            width="222"
            height="97"
          >
        </div>
      </section>
      <section class="contacts-feedback">
        <contacts-feedback></contacts-feedback>
      </section>
    </div>
  </div>
</template>

<script>
import ContactsAddress from '../components/the-content/ContactsAddress'
import ContactsFeedback from '../components/the-content/ContactsFeedback'
import ContactsGoogleMap from '../components/the-content/ContactsGoogleMap'
import ContactsOther from '../components/the-content/ContactsOther'
import ContactsPhones from '../components/the-content/ContactsPhones'
import ContactsWorkingHours from '../components/the-content/ContactsWorkingHours'
import utils from './utils'

export default {
  name: 'ContactsPage',
  components: {
    ContactsAddress,
    ContactsFeedback,
    ContactsGoogleMap,
    ContactsPhones,
    ContactsOther,
    ContactsWorkingHours
  },
  data () {
    return {
      section: {},
      workingHours: [],
      title: 'Где купить',
      imageForMetaUrl: utils.addDomainToPath(
        '/static/images/logo/logo-black-white-background-large.png'
      ),
      imageForMetaWidth: 1200,
      imageForMetaHeight: 1200
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: utils.getDefaultMetaTags({
        description: this.section.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.title,
        imageUrl: this.imageForMetaUrl,
        imageWidth: this.imageForMetaWidth,
        imageHeight: this.imageForMetaHeight
      })
    }
  },
  mounted () {
    this.getSection()
    this.getWorkingHours()
  },
  updated () {
    if (this.workingHours.length > 0 && window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  computed: {
    areWorkingHoursReady: function () {
      // for each day of week there should be information about working hours
      return (this.workingHours.length === 7)
    }
  },
  methods: {
    getSection: function () {
      const apiHost = process.env.API_HOST
      this.$http
        .get(`${apiHost}/api/v1/site-structure/get-section-with-categories/contacts`)
        .then(response => { this.section = response.body })
    },
    getWorkingHours: function () {
      this.$http
        .get(`${process.env.API_HOST}/api/v1/contacts/get-working-hours`)
        .then(response => { this.workingHours = response.body })
    }
  }
}
</script>

<style scoped lang="scss">
  .contacts-details-and-feedback {
    background-color: $default-background-color;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .contacts-details, .contacts-feedback {
      @include media (">tablet") { flex-basis: 50%; };
      @include media ("<=tablet") { flex-basis: 100%; };
    }
    .contacts-details {
      font-size: 1.1em;
      box-sizing: border-box;
      padding: 2em 1em;
      @include media (">tablet") {
        padding-right: 3em;
        text-align: right;
        >>> .phones-table,
        >>> .working-hours-table {
          margin: 0 0 0 auto;
          text-align: right;
        }
      };

      h1 {
        font-size: 1.5em;
        @include media (">tablet") {
          max-width: 380px;
          margin-left: auto;
          margin-right: 0;
        }
      }
      > * {
        margin-bottom: 1em;
        &:last-child { margin-bottom: 0; }
      }
      .logo-wrapper {
        padding-top: 0.5em;
        .logo {
          display: inline-block;
          width: 175px;
          height: auto;
          opacity: 0.8;
        }
        @media only print { display: none; }
      }
    }
    .contacts-feedback {
      @include media (">tablet") {
        box-sizing: border-box;
        padding-left: 3em;
        text-align: left;
        >>> .feedback {
          margin: 0 auto 0 0;
        }
      }
      @media only print {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ContactsPage.vue